import * as z from 'zod';

import { supportPrioritySchema, supportStatusSchema, supportTicketDetailSchema } from './support-query-schema';

// Support ticket creation payload schema
export const supportTicketCreateSchema = z.object({
  subject: z.string().min(1),
  description: z.string().min(1),
  priority: supportPrioritySchema,
  status: supportStatusSchema.optional(),
  type: z.string(),
  requester_id: z.number(),
  company_id: z.number().optional(),
  group_id: z.number().optional(),
  responder_id: z.number().optional(),
  tags: z.array(z.string()).optional(),
  custom_fields: z.record(z.string(), z.unknown()).optional(),
});

// Support ticket update payload schema
export const supportTicketUpdateSchema = z.object({
  subject: z.string().min(1).optional(),
  description: z.string().min(1).optional(),
  priority: supportPrioritySchema.optional(),
  status: supportStatusSchema.optional(),
  type: z.string().optional(),
  requester_id: z.number().optional(),
  responder_id: z.number().optional(),
  group_id: z.number().optional(),
  tags: z.array(z.string()).optional(),
  custom_fields: z.record(z.string(), z.unknown()).optional(),
});

// Support ticket patch schema (for partial updates)
export const supportTicketPatchSchema = z.object({
  tags: z.array(z.string()).optional(),
  type: z.string().optional(),
  status: supportStatusSchema.optional(),
  priority: supportPrioritySchema.optional(),
  group_id: z.number().nullable().optional(),
  responder_id: z.number().nullable().optional(),
});

// Support ticket delete schema
export const supportTicketDeleteSchema = z.object({
  id: z.number(),
  reason: z.string().optional(),
});

// Response schemas for mutations
export const supportTicketCreateResponseSchema = z.object({
  data: supportTicketDetailSchema,
  message: z.string().optional(),
});

export const supportTicketUpdateResponseSchema = z.object({
  data: supportTicketDetailSchema,
  message: z.string().optional(),
});

export const supportTicketDeleteResponseSchema = z.object({
  success: z.boolean(),
  message: z.string().optional(),
});

// Export types
export type SupportTicketCreateSchema = z.infer<typeof supportTicketCreateSchema>;
export type SupportTicketUpdateSchema = z.infer<typeof supportTicketUpdateSchema>;
export type SupportTicketPatchSchema = z.infer<typeof supportTicketPatchSchema>;
export type SupportTicketDeleteSchema = z.infer<typeof supportTicketDeleteSchema>;
export type SupportTicketCreateResponse = z.infer<typeof supportTicketCreateResponseSchema>;
export type SupportTicketUpdateResponse = z.infer<typeof supportTicketUpdateResponseSchema>;
export type SupportTicketDeleteResponse = z.infer<typeof supportTicketDeleteResponseSchema>;
